import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'

import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import Button from 'components/Button'
import { PageTitle, PageSubtitle, TooltipHintWrapper, PageSubtitleWrapper } from 'flow/siteProposal/pages/about/style'
import { Divider } from '@mui/material'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import AddDetailsPressure from '../PressureModal/AddDetailsPressure'
import PressureDetailsForm from '../PressureModal/PressureDetailsForm'

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
  margin-bottom: 24px;
`

const SelectedPressure = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: rgba(32, 32, 32, 0.9);
`
const CardHeader = styled.div`
  margin-bottom: 16px;
`
const GreyBox = styled.div`
  background: #f5f5f5;
  border: 1px solid #e6e6e6;
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const GreyBoxContent = styled.div`
  text-align: center;
`
const AddTriggerEvaluation = ({ item, onBack = () => {} }) => {
  const location = useLocation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedPressureNew, setSelectedPressureNew] = useState(null)
  const [selectedFlowTab, setSelectedFlowTab] = useState(() => location?.state?.openTab || 'species')
  const openModal = () => {
    setSelectedFlowTab('species')
    setIsModalOpen(true)
  }
  const closeModal = () => setIsModalOpen(false)
  const pressureName = item && (item.displayName || item.name) ? item.displayName || item.name : ''
  const tooltipXOffset = 0
  const tooltipYOffset = 16

  const truncate = (text, max = 60) => {
    if (text == null) return text
    const str = String(text)
    return str.length > max ? str.slice(0, max) + '....' : str
  }

  useEffect(() => {
    const requestedTab = location?.state?.openTab
    if (requestedTab === 'species' || requestedTab === 'ecosystems') {
      setSelectedFlowTab(requestedTab)
    }
  }, [location?.state?.openTab])

  return (
    <Container>
      <Row>
        <Col xs={12} md={10} mdOffset={1}>
          <Header>
            <SelectedPressure style={{ marginTop: '46px' }}>
              <span style={{ marginRight: 8 }}><FormattedMessage id="selectedPressureTitle" />:</span>
              <span>{pressureName}</span>
            </SelectedPressure>

            <Button type="secondary" height="40px" width="180px" onClick={onBack}>
              &larr;&nbsp; <FormattedMessage id="backToPressureBtnText" />
            </Button>
          </Header>
          <Divider />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={10} mdOffset={1}>
          <div style={{ paddingLeft: '62px', paddingRight: '62px' }}>
            <CardHeader>
              <PageTitle style={{ marginTop: '60px', textAlign: 'left' }}>
                <FormattedMessage id="threatTitle" defaultMessage="" />
              </PageTitle>
              <PageSubtitleWrapper style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <PageSubtitle data-test="sub-legend" style={{ textAlign: 'left' }}>
                  <FormattedMessage
                    id="threatSubTitle"
                    defaultMessage=""
                  />
                </PageSubtitle>
                <Tooltip
                  style={{ zIndex: 1000 }}
                  placement="bottom"
                  trigger={['hover']}
                  align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                  overlay={{
                    label: 'threatImpactTriggerTitle',
                    infoTooltip: 'threatImpactTriggerTitle'
                  }}
                  type="big"
                >
                  <TooltipHintWrapper>
                    <InfoIcon />
                  </TooltipHintWrapper>
                </Tooltip>
              </PageSubtitleWrapper>
            </CardHeader>

            <GreyBox>
              <GreyBoxContent style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ color: 'rgba(32,32,32,0.6)', marginTop: '32px' }}><FormattedMessage id="noTriggerSelectedText" />:</div>
                <Button type="primary" height="40px" style={{ marginTop: '0px', paddingTop: '0px' }} onClick={openModal}>
                  +&nbsp; <FormattedMessage id="addTriggerToThisEvaluationBtn" />
                </Button>
              </GreyBoxContent>
            </GreyBox>
          </div>
        </Col>
      </Row>
      {isModalOpen && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 72,
              left: 0,
              right: 0,
              bottom: 72,
              background: 'rgba(255,255,255,0.95)',
              zIndex: 9998
            }}
          />
          <div
            style={{
              position: 'fixed',
              top: 72,
              left: 0,
              right: 0,
              bottom: 72,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              padding: '16px 24px',
              overflow: 'auto',
              zIndex: 9999,
              boxSizing: 'border-box'
            }}
          >
            <AddDetailsPressure
              isOpen={true}
              modalTitleId={truncate(item?.displayName || item?.name || '')}
              autoSaveIcon={true}
              onClose={closeModal}
              titleValue={pressureName}
              threatItemId={item.threatItemId}
            >
              <PressureDetailsForm
                triggerItem={selectedPressureNew}
                onCancel={closeModal}
                threatItemId={item.threatItemId}
                titleValue={pressureName}
                SiteThreatTimingId={item?.SiteThreatTimingId}
                totalTriggers={true}
                setIsModalOpen={setIsModalOpen}
                parentTabSelected={selectedFlowTab}
                selectedSubTab={setSelectedFlowTab}
              />
            </AddDetailsPressure>
          </div>
        </>
      )}
    </Container>
  )
}

export default AddTriggerEvaluation
